export enum AbilityTriggerTypes {
  FallsBelow,
  RisesAbove,
  Both,
  Toggle,
}
